import EastRoundedIcon from '@mui/icons-material/EastRounded';
import { WestRounded } from '@mui/icons-material';
import {CustomButton, IconWrapper, ButtonText} from "./styles"

interface LearnMorButtonProps {
    text: string;
    east: boolean;
    enabled: boolean;
    onClick?: () => void;
  }

const EastOrWestButton = ({ text, east, enabled, onClick }: LearnMorButtonProps) => {
    return (
      <CustomButton variant="outlined" onClick={onClick} enabled={enabled}>
        <IconWrapper>
          {east ? <EastRoundedIcon fontSize="large" /> : <WestRounded fontSize="large" />}
          
        </IconWrapper>
        <ButtonText>{text}</ButtonText>
      </CustomButton>
    );
  };
  
  export default EastOrWestButton;